export default __webpack_public_path__ + "static/media/Staff of the Primal Spirit.adaf5167.jpg";